export function apiToken() {
    const user = JSON.parse(localStorage.getItem('activeUser'));
    return user ? user.token : null;
}

export function tokenHeader() {
    let token = apiToken();
    return token ? {headers: {authorization: `Token ${token}`}, withCredentials: false}: {};
}


// WEBPACK FOOTER //
// ./src/utils/headers.js